import { Header } from "@/components/layout/Header";
import React from "react";

const Footer = () => (
  <footer className="bg-gray-900 text-white py-12 mt-20">
    <div className="container px-4 mx-auto">
      <div className="flex flex-col md:flex-row justify-between items-center">
        <div className="mb-6 md:mb-0">
          <h2 className="text-xl font-bold">Openstudio</h2>
          <p className="text-gray-400 mt-2">Oživte prázdné prostory s Openstudio</p>
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          <div>
            <h3 className="text-lg font-medium mb-2">Služby</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">Virtuální zařízení</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Interiérový design</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Realitní služby</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-medium mb-2">Společnost</h3>
            <ul className="space-y-2">
              <li><a href="/kontakt" className="text-gray-400 hover:text-white">Kontakt</a></li>
              <li><a href="/ochrana-osobnich-udaju" className="text-gray-400 hover:text-white">Ochrana osobních údajů</a></li>
              <li><a href="/obchodni-podminky" className="text-gray-400 hover:text-white">Všeobecné obchodní podmínky</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-12 pt-6 text-center">
        <p className="text-gray-400">© {new Date().getFullYear()} Openstudio. Všechna práva vyhrazena.</p>
      </div>
    </div>
  </footer>
);

const Kontakt = () => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1 flex flex-col items-center justify-center py-20">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-12">
        <div className="flex-1 max-w-xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">Potřebujete pomoc</h1>
          <p className="text-lg text-gray-700">
            Potřebujete poradit s virtuálním home stagingem nebo máte otázky ohledně naší služby? Jsme tu pro vás – neváhejte nás kontaktovat, rádi vám pomůžeme!
          </p>
        </div>
        <div className="flex-1 max-w-xl bg-white shadow-xl rounded p-12 text-center">
          <div className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">+420 777 726 001</div>
          <div className="text-gray-500 mb-8">Po. - Pá. 9:00–18:00</div>
          <div className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            <a href="mailto:info@openstudio.cz" className="hover:underline">info@openstudio.cz</a>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default Kontakt; 